import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenManager } from './tokenManager';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { LabOrderApiService } from './lab-order-api.service';
import { ReferenceListItem } from './data/reference-list-item';

export class RefListType {

  constructor (public refList: string, public endpoint: string, public isExternallyProvided: boolean = false ) {}
}

export class RefList {

  VISION_TYPE: RefListType = new RefListType('visiontypes', 'visiontypes');
  WHICH_LENSES: RefListType = new RefListType('whichLensRx', 'whichLensRx');
  LENS_MATERIAL_TYPES: RefListType = new RefListType('lensmaterialtypes', 'lensmaterialtypes');
  SEGMENT_MEASUREMENT_TYPES: RefListType = new RefListType('segmentmeasurementtypes', 'segmentmeasurementtypes');
  THICKNESS_TYPE_CODES: RefListType = new RefListType('thicknesstypecodes', 'thicknesstypecodes');
  HORIZONTAL_PRISM_DIRECTION_TYPES: RefListType = new RefListType('horizontalprismdirectiontypes', 'horizontalprismdirectiontypes');
  EYE_MEASUREMENT_DEVICE_DESCRIPTIONS: RefListType =
    new RefListType('eyemeasurementdevicedescriptions', 'eyemeasurementdevicedescriptions');
  OPTICAL_CENTER_MEASUREMENT_TYPES: RefListType = new RefListType('opticalcentermeasurementtypes', 'opticalcentermeasurementtypes');
  PUPILLARY_DISTANCE_TYPES: RefListType = new RefListType('pupillarydistancetypes', 'pupillarydistancetypes');
  EDGE_CODES: RefListType = new RefListType('edgecodes', 'edgecodes');
  VERTICAL_PRISM_DIRECTION_TYPES: RefListType = new RefListType('verticalprismdirectiontypes', 'verticalprismdirectiontypes');
  STATUSES: RefListType = new RefListType('statuses', 'statuses');
  SUPPLIERS: RefListType = new RefListType('suppliers', 'suppliers');
  BEVEL_CODES: RefListType = new RefListType('bevelcodes', 'bevelcodes');
  SHAPES: RefListType = new RefListType('shapes', 'shapes');
  TINT_SAMPLE_CODES: RefListType = new RefListType('tintsamplecodes', 'tintsamplecodes');
  TINT_COLOR_CODES: RefListType = new RefListType('tintcolorcodes', 'tintcolorcodes');
  TINT_TYPE_CODES: RefListType = new RefListType('tinttypecodes', 'tinttypecodes');
  FRAME_MATERIAL_TYPES: RefListType = new RefListType('framematerialtypes', 'framematerialtypes');
  BALANCE_LENSES: RefListType = new RefListType('balancelenses', 'balancelenses');

  // Externally-provided reference lists come from a source other than the lab order API.
  // In order to fetch them, we need to know the endpoint from which to fetch them.  In the
  // case of lens styles and coating lists, the "endpoints" are currently json files.  This
  // may change in the future as external reference data APIs become available.

  // LENS_STYLES: { refList: 'lensStyles', endpoint: "src/app/business-services/laborder-reference-service/data/lens-style-update.json" },
  AR_COATINGS: RefListType = new RefListType('arCoatings', 'assets/lens-ar-coatings.json', true);
  GLASS_COATINGS: RefListType = new RefListType('glassCoatings', 'assets/lens-glass-coatings.json', true );
  MIRROR_SKI_COATINGS: RefListType = new RefListType('mirrorSkiCoatings', 'assets/lens-mirror-coatings.json', true );
  SCRATCH_COATINGS: RefListType = new RefListType('scratchCoatings', 'assets/lens-scratch-coatings.json', true );
  UV_COATINGS: RefListType = new RefListType('uvCoatings', 'assets/lens-uv-coatings.json', true );
  SPECIAL_INSTRUCTIONS: RefListType = new RefListType('specialInstructions', 'assets/special-instructions.json', true );
  FRAME_SUPPLIED_BY: RefListType = new RefListType('frameSuppliedBy', 'assets/frame-supplied-by.json', true);
  // LENS_FINISHING: { refList: 'finishingTypes',
  //  endpoint: "src/app/business-services/laborder-reference-service/data/lens-finishing-types.json" }
}

export const REF_LIST: RefList = new RefList();

@Injectable()
export class LabOrderReferenceApiService {

  constructor(private http: HttpClient, private tokenManager: TokenManager, private apiService: LabOrderApiService) { }

  apiEndpoint: string = environment.apiEndpoint.toString();

  getReferenceListsByNames(referenceLists: RefListType[]) {
    // pass in headers because token is required by web-service.
    const httpHeaders = this.apiService.getHttpHeaders();

    const observableBatch = [];

    referenceLists.forEach((refList) => {
      if (refList.isExternallyProvided) {
        observableBatch.push(this.http.get<ReferenceListItem[]>(refList.endpoint));
      } else {
        observableBatch.push(this.http.get<ReferenceListItem[]>
          (this.apiEndpoint + 'referencelists/' + refList.endpoint, {'headers': httpHeaders}));
      }
    });

    // don't return all reference lists until last web-service call returns.
    return Observable.forkJoin(observableBatch);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/lab-order-reference-api.service.ts